import { CircularProgress } from "@material-ui/core";
import React, { useRef, useContext } from "react";
import { AiOutlineEnter } from "react-icons/ai";
import styles from "./styles.module.css";
import { GET_DATA_FROM_URL } from "../../../api.json";
import useOnClickOutside from "../../../atoms/Modal/useOnClickOutside";
import { useState } from "react";
import SVGIcon from "../../../atoms/SVGIcon";
import Textfield from "../../../atoms/CustomTextfield/Textfield";
import useHelperFunctions from "../../../helperFunctions";
import ReportContext from "../../Research/ReportContext";
import Button from "../../../atoms/Button/Button";
import LoadingDots from "../../../atoms/LoadingDots/LoadingDots";

function URL({
    setImportFromUrlModal,
    setIsLoadingTextFromUrl,
    isLoadingTextFromUrl,
}) {
    const [url, setUrl] = useState("");
    const [error, setError] = useState(false);
    const { getData } = useHelperFunctions();
    const { setMetaData } = useContext(ReportContext);

    async function getDataFromUrl(val) {
        if (!val) return;
        setIsLoadingTextFromUrl(true);
        const editor = document.quill.editor;
        if (/^\w+:/.test(val));
        else if (!/^https?:/.test(val)) val = "https://" + val;

        const response = await getData({
            url: GET_DATA_FROM_URL + "?url=" + val,
        });
        if (response.status == 200) {
            setImportFromUrlModal(false);
            if (response.data.data && response.data.data.delta) {
                editor.setContents(response?.data?.data?.delta, "api");
                setMetaData({
                    ...response.data?.data?.meta_description,
                    fromAPI: true,
                });
            } else if (response.data.data && response.data.data.content) {
                editor.deleteText(0, editor.getLength());
                await editor.pasteHtml(
                    editor.cursor,

                    response?.data?.data?.content + " ",
                    "api",
                );
            }
        }
        setIsLoadingTextFromUrl(false);
    }

    return (
        <div
            className={
                styles.importDiv +
                " " +
                (isLoadingTextFromUrl && styles.loadingText)
            }
        >
            {!isLoadingTextFromUrl ? (
                <>
                    <span className={styles.seoModalCross}>
                        <SVGIcon
                            onClick={() => setImportFromUrlModal(false)}
                            src="/New UI/SVG/cross.svg"
                        ></SVGIcon>
                    </span>
                    <h3>
                        <SVGIcon src="/New UI/SVG/link.svg"></SVGIcon>
                        &nbsp;&nbsp; Import from URL
                    </h3>
                    <div className={styles.importDivInput}>
                        <Textfield
                            variant="filled"
                            value={url}
                            width={"100%"}
                            label=""
                            placeholder="Enter URL"
                            errMsg={error ? "Enter a valid URL" : ""}
                            props={{
                                style: {
                                    margin: 0,
                                    padding: "0px 10px",
                                },
                                onBlur: (e) => {
                                    !e.target.value.trim() && setError(true);
                                },
                                onKeyDown: (e) => {
                                    if (e.key == "Enter") {
                                        getDataFromUrl(url);
                                        e.target.blur();
                                    }
                                },
                                onChange: (e) => {
                                    setError(false);
                                    setUrl(e.target.value.trim());
                                },
                            }}
                        ></Textfield>
                        <div className={styles.btnContainer}>
                            <Button
                                text={
                                    !isLoadingTextFromUrl ? (
                                        "Import"
                                    ) : (
                                        <>
                                            Importing <LoadingDots />
                                        </>
                                    )
                                }
                                width={"130px"}
                                handler={(e) => {
                                    getDataFromUrl(url);
                                }}
                                disabled={isLoadingTextFromUrl}
                            />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className={styles.inProgRefresh}>
                        <span>
                            Please wait while we are importing your content...{" "}
                        </span>
                        <LoadingDots
                            customStyle={{
                                height: "24px",
                                width: "24px",
                                color: "inherit",
                            }}
                        />
                    </div>
                </>
            )}
        </div>
    );
}

export default URL;
